module.exports = __webpack_public_path__ + "static/img/p7.8d220e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p7.png
// module id = KWqL
// module chunks = 15